import { pageLinks } from './TopBar.tsx';
export function Close() {
  return <footer className="launch-footer wrap" id="close">
    <div><img src="/persivo-lockup-horizontal.svg" alt="Persivo"/><p>Your product. A personal demonstration.</p></div>
    <nav aria-label="Footer">
      {pageLinks.map(([href, label]) => <a href={href} key={href}>{label}</a>)}
      <a href="#try">Take a demo ↗</a>
      <a href="#pilot">Request a pilot ↗</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="mailto:hemant@persivo.co">Contact</a>
    </nav>
  </footer>;
}
